import { z } from 'zod';

export const JsonObjectSchema = z.string().transform((str, ctx): z.infer<ReturnType<typeof Object>> => {
  try {
    return JSON.parse(str);
  } catch (_error: unknown) {
    ctx.addIssue({ code: 'custom', message: 'Invalid JSON' });
    return z.NEVER;
  }
});
